import { Component, Input, SimpleChange } from '@angular/core';
import { ReferenceRecord, RFQReferenceRecord } from './dto/reference-record.model';
import { BaseTableColumn } from 'src/app/shared/models/app-models/BaseTableColumn.model';
import { ReferenceRecordColumns, ReferenceRFQRecordColumns } from '../../shared/constants';
import { BackendApiService } from 'src/app/core/services/backend-api';
import { MyPurchaseForm } from 'src/app/shared/models/app-models';
import { Subject, Subscription, distinctUntilChanged, filter, lastValueFrom, takeUntil } from 'rxjs';
import { Store } from '@ngrx/store';
import { doesNotMeetRfsCriteria } from '../../shared/utils/check-rfs-criteria';
import { DocumentReference } from 'src/app/shared/models/database-models/DocumentReference.model';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment'; import { DeletedItemVendorsState } from 'src/app/core/store/DeletedItemVendors.reducer';
import { MatTableDataSource } from '@angular/material/table';
import { decrementLoading, incrementLoading } from 'src/app/core/store/loading.action';
import { LoadingState } from 'src/app/core/store/loading.reducer';
import { isEqual } from 'lodash';


export interface rfqGroupedData {
  RFQNumber: string;
  groupedSummary: string;
  podocs: string;
  MPDocumentNumber: string;
}
@Component({
  selector: 'app-reference',
  templateUrl: './reference.component.html',
  styleUrls: ['./reference.component.scss']
})
export class ReferenceComponent {
  form?: MyPurchaseForm
  parentDocumentNo: any = '';
  childDocArray: ReferenceRecord[] = [];
  rfqRecordArr: DocumentReference[] = [];
  documentRefereceStatus: boolean = false;
  isChild: boolean = false
  purchaseType: string = '';
  purchaseOrderRef: any = []
  evaluationReportRef: any = []
  contractReportRef: any = []
  destroy$: Subject<boolean> = new Subject<boolean>();
  deletedItemMappings: Map<number, { itemId: number, displayItemNumber: number }> = new Map<number, { itemId: number, displayItemNumber: number }>()
  displayedColumns: BaseTableColumn<ReferenceRecord>[] = ReferenceRecordColumns;
  RFQColumns: BaseTableColumn<rfqGroupedData>[] = ReferenceRFQRecordColumns;
  processedRFQData: rfqGroupedData[] = [];
  displayedRFQColumns: string[] = [];
  RFQReferencedataSource: MatTableDataSource<rfqGroupedData> = new MatTableDataSource<rfqGroupedData>([]);
  private loadingSubscription: Subscription = new Subscription();
  isLoading = false;
  rfqRefRecord: RFQReferenceRecord[] = [];
  isrfsDoc: boolean = false;

  constructor(private backendService: BackendApiService, private router: Router, private route: ActivatedRoute, private store: Store<{
    form: MyPurchaseForm,
    deletedItemVendors: DeletedItemVendorsState,
    loading: LoadingState
  }>) {
    this.loadingSubscription = this.store.select('loading').subscribe((loadingState) => {
      this.isLoading = loadingState.loadingStates['MPNDocReference'] > 0;
    });
    this.purchaseType = this.route.snapshot.params['purchaseType'].split(';')[0] as string;
      this.store
      .select('form')
      .pipe(distinctUntilChanged((prev, curr) => 
        // when document id changed
        prev.documentNo == curr.documentNo 
        && prev.PurchaseTypeId == curr.PurchaseTypeId 
        && prev.parentDocumentNo == curr.parentDocumentNo 
        // when document status changed
        && prev.documentStatusId == curr.documentStatusId
        // when workflow status changed
        && prev.documentSubStatusId == curr.documentSubStatusId
        // when isRFSEnabled flag changed
        && prev.isRFSEnabled == curr.isRFSEnabled
        // when something on the itemList changed
        && isEqual(prev.ItemList, curr.ItemList)
      ))
      .pipe(takeUntil(this.destroy$))
      .subscribe(async (form: MyPurchaseForm) => {
        this.form = form;
        this.parentDocumentNo = form.parentDocumentNo ?? '-';
        this.isChild = form.parentDocumentNo ? true : false;

        if (this.childDocArray.length == 0) {
          await this.checkRFS()
        }
        this.isrfsDoc = this.purchaseType === 'rfq' && !!this.form?.isRFSEnabled;
        if (this.documentRefereceStatus === false && !this.isrfsDoc) {
          this.getDocumnetReference(form)
        }
      })

    this.store
      .select('form')
      // only fire a observable change when one of the flags is different
      // flag depends on the properties we needed to check, it could be anything
      // that we want to run a process when that property changed
      // this should help to reduce unnecessary processes or api calls
      .pipe(distinctUntilChanged((prev, curr) => 
        // when document id changed
        prev.documentNo == curr.documentNo 
      ))
      .pipe(takeUntil(this.destroy$))
      .subscribe(async (form: MyPurchaseForm) => {
        if (this.childDocArray.length == 0) {
          await this.loadReferenceTable(form);
        }
        this.isrfsDoc = this.purchaseType === 'rfq' && !!this.form?.isRFSEnabled;
        if (!this.isrfsDoc) {
          await this.getDocumnetReference(form)
        } else {
          await this.getRFQReferenceRecord(form);
        }
      })

    this.store.select('deletedItemVendors')
      .pipe(distinctUntilChanged((prev, curr) => isEqual(prev, curr)))
      .pipe(filter(x => x.rfsSourcingOutcomes != null), takeUntil(this.destroy$))
      .subscribe(async (deletedItemVendors: DeletedItemVendorsState) => {
        if (deletedItemVendors) {
          this.deletedItemMappings = deletedItemVendors.deletedItemMappings
          await this.checkRFS()
        }
      })
  }
  checkForReferenceID(itemList: any) {
    let isReferenced = itemList.some((item: any) => item.AddItems.ReferenceId);
    return isReferenced;
  }
  getChildItemMappings(result: ReferenceRecord[]) {
    let childItemMappings: Map<string, number[]> = new Map<string, number[]>()
    result.forEach((record: ReferenceRecord) => {
      if (childItemMappings.has(record.childDocumentNumber)) {
        let itemIds = childItemMappings.get(record.childDocumentNumber)
        itemIds!.push(Number(record.childItemNumber.at(0)!.PurchaseItemId))
        itemIds!.sort((a, b) => a - b)
        childItemMappings.set(record.childDocumentNumber, itemIds!)
      }
      else childItemMappings.set(record.childDocumentNumber, [Number(record.childItemNumber.at(0)!.PurchaseItemId)])
    })
    return childItemMappings
  }
  async checkRFS() {
    if (!this.isChild && (!this.form || doesNotMeetRfsCriteria(this.form))) return
    console.log('reference component checkRFS', this.isChild, this.childDocArray)
    if (this.childDocArray.length == 0 && this.form && this.form.documentNo) {
      let result: ReferenceRecord[] = await lastValueFrom(this.backendService.getReferenceTable(this.form.documentNo!))
      //get Parent child id mappings
      this.childDocArray = result
    }
    let childItemMappings = this.getChildItemMappings(this.childDocArray)
    let result: ReferenceRecord[] = []
    result = this.childDocArray.map(record => {
      let childItemIdArr = childItemMappings.get(record.childDocumentNumber) || []
      let newRecord: ReferenceRecord = {
        ...record,
        displayedParentId: this.isChild ? this.returnParentItemNumberForChildDocument(record) : this.returnParentItemNumberForParentDocument(record),
        displayedChildId: this.isChild ? this.returnChildItemNumberForChildDocument(record) : this.returnChildItemNumberForParentDocument(record, childItemIdArr)
      }
      return newRecord
    })
    this.childDocArray = result
  }
  returnChildItemNumberForChildDocument(record: ReferenceRecord): string {
    const itemNumbers = record.childItemNumber.map(items => {
      if (items.ItemNumber) {
        return items.ItemNumber.toString()
      } else {
        let formitem = this.form?.ItemList.find(x => x.AddItems.PurchaseItemId == Number(items.PurchaseItemId))
        return formitem?.AddItems.displayItemNumber.toString() || items.PurchaseItemId.toString()
      }
    })
    return itemNumbers.join(',');
  }
  returnChildItemNumberForParentDocument(record: ReferenceRecord, childItemIdArr: number[]): string {
    const itemNumbers = record.childItemNumber.map(items => {
      if (items.ItemNumber) {
        return items.ItemNumber.toString()
      } else {
        return childItemIdArr.indexOf(Number(items.PurchaseItemId)) == -1 ? String(record.childItemNumber.at(0)!.PurchaseItemId) : (childItemIdArr.indexOf(Number(items.PurchaseItemId)) + 1).toString()
      }
    })
    return itemNumbers.join(',');
  }
  returnParentItemNumberForChildDocument(record: ReferenceRecord): string {
    const itemNumbers = record.parentItemNumber.map(item => {
      if (item.ItemNumber) {
        return item.ItemNumber.toString();
      } else {
        return record.parentItemIndex[item.PurchaseItemId] || item.PurchaseItemId.toString();
      }
    });
    return itemNumbers.join(',');
  }
  returnParentItemNumberForParentDocument(record: ReferenceRecord): string {
    const itemNumbers = record.parentItemNumber.map(item => {
      if (item.ItemNumber)
        return item.ItemNumber.toString()
      else {
        let deletedItemNumber = this.deletedItemMappings.get(Number(item.PurchaseItemId))?.displayItemNumber
        return deletedItemNumber ? String(deletedItemNumber) : String(item.PurchaseItemId)
      }
    });
    return itemNumbers.join(',');
  }
  async loadReferenceTable(form: MyPurchaseForm) {
    if (form.parentDocumentNo) {
      let result: ReferenceRecord[] = await lastValueFrom(this.backendService.getReferenceTable(form.parentDocumentNo!))
      this.childDocArray = result
    }
  }
  async getDocumnetReference(form: MyPurchaseForm) {
    if (form.documentNo) {
      let results: DocumentReference[] = await lastValueFrom(this.backendService.getDocumentReference(form.documentNo))
      const EvaluationReportFilter = results.filter(item => item.DocumentTypeName === 'EvaluationReport');
      const PurchaseOrderFilter = results.filter(item => item.DocumentTypeName === 'PurchaseOrder');
      const ContractFilter = results.filter(item => item.DocumentTypeName === 'Contract');
      this.purchaseOrderRef = PurchaseOrderFilter;
      this.evaluationReportRef = EvaluationReportFilter;
      this.contractReportRef = ContractFilter;
      this.documentRefereceStatus = true;
    }
  }

  async redirectMMS(DocumentEntityName: string, DocumentID: String) {
    const url = environment.mmsURL + "/" + DocumentEntityName + "/display/" + DocumentID;
    window.open(url, '_blank');
  }

  async getRFQReferenceRecord(form: MyPurchaseForm) {
    if (form.documentNo) {
      this.store.dispatch(incrementLoading({ context: 'MPNDocReference' }));
      try {
        let results: RFQReferenceRecord[] = await lastValueFrom(this.backendService.getrfqReference(form.documentNo));
        this.rfqRefRecord = results;
        this.processRFQData(results);
      }
      catch (error) {
        console.log(error);
      }
      finally {
        this.store.dispatch(decrementLoading({ context: 'MPNDocReference' }));
      }
    }
  }
  processRFQData(data: RFQReferenceRecord[]) {
    this.store.dispatch(incrementLoading({ context: 'MPNDocReference' }));
    const rfqMap = new Map<string, any>();

    data.forEach(item => {
      const { RFQNumber, MPDocumentNumber, RFQSummaryNumber, ERDocumentNumber, PODocumentNumber } = item;

      // Check if the RFQNumber already exists in the map
      let existingEntry = rfqMap.get(RFQNumber);

      if (!existingEntry) {
        // If the RFQNumber doesn't exist, create a new entry
        existingEntry = {
          RFQNumber,
          MPDocumentNumber,
          groupedSummary: this.formatSummary(RFQSummaryNumber, ERDocumentNumber),
          podocs: PODocumentNumber ? PODocumentNumber : null,
        };
        rfqMap.set(RFQNumber, existingEntry);
      } else {
        // If the RFQNumber exists, add the new summary/ER and PODocumentNumber to the existing entry
        if (RFQSummaryNumber && !existingEntry.groupedSummary?.includes(RFQSummaryNumber)) {
          existingEntry.groupedSummary += `, ${RFQSummaryNumber}`;
        }
        if (ERDocumentNumber && !existingEntry.groupedSummary?.includes(ERDocumentNumber)) {
          existingEntry.groupedSummary += `, ${ERDocumentNumber}`;
        }

        // Only append PODocumentNumber if it's not null or undefined
        if (PODocumentNumber) {
          if (!existingEntry.podocs?.includes(PODocumentNumber)) {
            existingEntry.podocs = existingEntry.podocs ? `${existingEntry.podocs}, ${PODocumentNumber}` : PODocumentNumber;
          }
        }
      }
    });

    // Convert the map into an array for display
    this.processedRFQData = Array.from(rfqMap.values()).map(entry => {
      if (!entry.podocs) {
        entry.podocs = '';
      }

      return entry;
    });

    this.displayedRFQColumns = this.RFQColumns.map(c => c.columnDef);
    this.RFQReferencedataSource.data = this.processedRFQData;
    this.store.dispatch(decrementLoading({ context: 'MPNDocReference' }));
  }

  formatSummary(RFQSummaryNumber: string | null, ERDocumentNumber: string | null): string {
    if (RFQSummaryNumber || ERDocumentNumber) {
      return `${RFQSummaryNumber || ''}${RFQSummaryNumber && ERDocumentNumber ? ', ' : ''}${ERDocumentNumber || ''}`;
    }
    return '';
  }

  onPONumberClick(poNumber: string) {
    const poObject = this.rfqRefRecord.find(item => item.PODocumentNumber === poNumber);
    if (poObject) {
      const url = environment.mmsURL + "/PurchaseOrder/display/" + `${poObject.PODocumentID}`;
      console.log('navigating to PO URL', url);
      window.open(url, '_blank');
    }
  }

  onSummaryDocClick(summaryNumber: string) {
    let url = ''
    if (summaryNumber.startsWith('ER')) {
      const erObject = this.rfqRefRecord.find(item => item.ERDocumentNumber === summaryNumber);
      if (erObject) {
        url = environment.mmsURL + "/EvaluationReport/display/" + `${erObject.ERDocumentID}`;
        console.log('navigating to ER URL', url);
      }
    } else if (summaryNumber.startsWith('RS')) {
      url = '/rfqSummary/' + `${summaryNumber}`;
    }
    window.open(url, '_blank');
  }

  async onRFQNumberClick(row: rfqGroupedData) {
    try {
      let response: any = await lastValueFrom(
        this.backendService.downloadReferenceRFQ(row.MPDocumentNumber, row.RFQNumber));

      if (!response || !response.files || !Array.isArray(response.files)) {
        throw new Error();
      }
      for (const [index, file] of response.files.entries()) {
        const arrayBuffer: any = file.data;
        const int8Array = new Uint8Array(arrayBuffer);
        let blob = new Blob([int8Array], { type: 'application/pdf' });
        const fileURL = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = row.RFQNumber + '_' + index;
        a.click();
        window.URL.revokeObjectURL(a.href);
      }
    } catch (e) {
      console.log('Error downloading file(s).', e);
      alert('Error downloading file(s).');
    }
  }
}
